import React, { useState } from "react";
import { GearFill } from "react-bootstrap-icons";

export const Loading = () => {
  return (
    <div className="spinner-border common-loading" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export const Toggle = (props) => {
  const [isToggleOn, setIsToggleOn] = useState(false);

  const changeToggle = async () => {
    await setIsToggleOn(!isToggleOn);
    if (!isToggleOn) {
      window.scrollBy({
        top: window.scrollY,
        left: 0,
        behavior: 'smooth'
      });
    }
  };

  return (
    <>
      <GearFill
        onClick={changeToggle}
        style={{ verticalAlign: "text-bottom", cursor: "pointer" }}
        size={16}
        className="mb-4"
      />
      {isToggleOn ? props.children : null}
    </>
  );
};
